import { AutorizationService } from 'src/app/api/autorization.service';
import { PopupUserComponent } from './popup-user/popup-user.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { error } from '@angular/compiler/src/util';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { UserApi } from 'src/app/models/api_models/user';
import { UserApiService } from 'src/app/user-api.service';
import { AutorisationCameraComponent } from './autorisation-camera/autorisation-camera.component';


@Component({
  selector: 'app-user-profil',
  templateUrl: './user-profil.component.html',
  styleUrls: ['./user-profil.component.scss']
})
export class UserProfilComponent implements OnInit {

  @ViewChild('fileInput') fileUploader: ElementRef;
  @ViewChild('fileInputBack') fileUploaderBack: ElementRef;

  @ViewChild('fileInputAttachement1') fileUploaderAttachement1: ElementRef;
  @ViewChild('fileInputAttachement2') fileUploaderAttachement2: ElementRef;
  @ViewChild('fileInputAttachement3') fileUploaderAttachement3: ElementRef;
  @ViewChild('fileInputAttachement4') fileUploaderAttachement4: ElementRef;


  uploadFormPermis: FormGroup;
  uploadFormAttachements: FormGroup;

  constructor(private MatDialog: MatDialog, private AutorizationService: AutorizationService, private dialog: MatDialog, private activatedRoute: ActivatedRoute, private translate: TranslateService, public snackBar: MatSnackBar, private formBuilder: FormBuilder, public sanitizer: DomSanitizer, private userApiService: UserApiService) 
  
  {

     this.activatedRoute.queryParamMap.subscribe(query => {

      let querytoken: any = query.get('token')
      console.log(query)
      console.log('querytoken')
      console.log(querytoken)

      if(querytoken != null){
      let expiredDate = new Date();
      expiredDate.setDate(expiredDate.getDate() + 7);
      let token = { "access_token": querytoken, "refresh_token": null, "expires_in": expiredDate, "grant_type": "user_grant" }
      localStorage.setItem('token_clem_mobi', JSON.stringify(token));
      }

    });



   }


  categorie1 = false;
  question1_1 = false;
  question1_2 = false;


  currentUser: UserApi;
  loaded: boolean = true;
  IsWait: boolean = true;

  nameFilePermis: string;
  nameFilePermisBack: string;

  nameFileAttachement1: string;
  nameFileAttachement2: string;
  nameFileAttachement3: string;
  nameFileAttachement4: string;


  iSupdatePermis = false;
  iSupdateAttachments = false;
  iSupdateSelfie = false;

  selfieImg: any;

  code_promo: any


    //selfie
    WIDTH = 1136;
    HEIGHT = 840;
    @ViewChild("video") video: ElementRef;
    @ViewChild("canvas") canvas: ElementRef;
    isCaptured: boolean;
    error: any;
  


  public getUserImg() {
    if (this.currentUser.profile_picture !== null) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.profile_picture?.mimetype};base64,${this.currentUser?.profile_picture?.file}`)
    }
  }

  public getPermisImg() {
    if (this.currentUser.license !== null) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.license?.mimetype};base64,${this.currentUser?.license?.source}`)
    }
  }



  public getSelfieImg() {
    if (this.currentUser.selfie_file.file !== null) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:image/png;base64,${this.currentUser?.selfie_file?.file}`)
    }
  }

  public getPermisversoImg() {
    if (this.currentUser.license_back !== null) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.license_back?.mimetype};base64,${this.currentUser?.license_back?.source}`)
    }
  }


  public getAttachement1() {
    if (this.currentUser.attachments[0] !== undefined) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.attachments[0]?.mimetype};base64,${this.currentUser?.attachments[0]?.source}`)
    }
  }


  public getAttachement2() {
    if (this.currentUser.attachments[1] !== undefined) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.attachments[1]?.mimetype};base64,${this.currentUser?.attachments[1]?.source}`)
    }
  }


  public getAttachement3() {
    if (this.currentUser.attachments[2] !== undefined) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.attachments[2]?.mimetype};base64,${this.currentUser?.attachments[2]?.source}`)
    }
  }



  public getAttachement4() {
    if (this.currentUser.attachments[3] !== undefined) {
      return this.sanitizer.bypassSecurityTrustUrl(`data:${this.currentUser?.attachments[3]?.mimetype};base64,${this.currentUser?.attachments[3]?.source}`)
    }
  }


  updatePermis() {
    this.iSupdatePermis = true;
  }

  updateAttachments() {
    this.iSupdateAttachments = true;
  }

  updateSelfie() {
    this.iSupdateSelfie = true;
    this.setupDevices()
  }

  // creation form permis
  createFormPermis() {
    this.uploadFormPermis = this.formBuilder.group({
      license: [''],
      license_back: ['']
    });
  }
  // creation form justificatifs
  createFormAttachements() {
    this.uploadFormAttachements = this.formBuilder.group({
      attachement1: [''],
      attachement2: [''],
      attachement3: [''],
      attachement4: [''],
    });
  }


  sendPermis() {

    let form = this.uploadFormPermis.value
    let body: any = {};
    body.license = form.license
    body.license_back = form.license_back
    if (body.license === "") { delete body.license }
    if (body.license_back === "") { delete body.license_back }
    // console.log(body)
    if (body.license || body.license_back) {
      // console.log('ghiles')
      this.userApiService.patchUserDetail(body).subscribe(response => {
        // console.log('cccc')
        // console.log(response)
        //this.openSnackBar("Votre permis a été changé avec succès")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.PERMIS'))
        location.reload()
      }, error => {
        //this.openSnackBar("Le type de votre justificatif n'est pas supporté")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.JUSTIFICATIFKO'))
      })
    }
  }



  postCodePromo() {

      this.userApiService.postCodePromo().subscribe(response => {
        // console.log('cccc')
        console.log(response)
        //this.openSnackBar("Votre permis a été changé avec succès")
        this.openSnackBar('Votre code promo a été obtenu avec succès')
        this.getCodePromo()
      }, error => {
        //this.openSnackBar("Le type de votre justificatif n'est pas supporté")
        this.openSnackBar(error.error.message)
      })
    
  }

  getCodePromo() {

    this.userApiService.getCodePromo().subscribe(response => {
      // console.log('cccc')
      console.log(response)
      this.code_promo = response.data

    }, error => {
      //this.openSnackBar("Le type de votre justificatif n'est pas supporté")
      // this.openSnackBar(error.error.message)
    })
  
}


copyMessage(val: string){
  const selBox = document.createElement('textarea');
  selBox.style.position = 'fixed';
  selBox.style.left = '0';
  selBox.style.top = '0';
  selBox.style.opacity = '0';
  selBox.value = val;
  document.body.appendChild(selBox);
  selBox.focus();
  selBox.select();
  document.execCommand('copy');
  document.body.removeChild(selBox);
  this.openSnackBar("Le code promo est copié avec succès")
}



  sendAttachements() {
    let form = this.uploadFormAttachements.value
    let body: any = {};
    body.attachment = form.attachement1
    body.attachment_back = form.attachement2
    body.attachment3 = form.attachement3
    body.attachment4 = form.attachement4
    if (body.attachment === "") { delete body.attachment }
    if (body.attachment_back === "") { delete body.attachment_back }
    if (body.attachment3 === "") { delete body.attachment3 }
    if (body.attachment4 === "") { delete body.attachment4 }
    // console.log(body)
    if (body.attachment || body.attachment_back || body.attachment3  || body.attachment4 ) {
      // console.log('ghiles')
      this.userApiService.patchUserDetail(body).subscribe(response => {
        // console.log('cccc')
        // console.log(response)
        //this.openSnackBar("Votre justificatif a été changé avec succès")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.JUSTIFICATIFOK'))
        location.reload()
      }, error => {
        //this.openSnackBar("Le type de votre justificatif n'est pas supporté")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.JUSTIFICATIFKO'))
      }
      )
    }
  }



  sendSelfie() {

    let body: any = { selfie_file: this.selfieImg };

      this.userApiService.patchUserDetail(body).subscribe(response => {
        // console.log('cccc')
        // console.log(response)
        //this.openSnackBar("Votre permis a été changé avec succès")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.PERMIS'))
        location.reload()
      }, error => {
        //this.openSnackBar("Le type de votre justificatif n'est pas supporté")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.JUSTIFICATIFKO'))
      })
  
  }



  unsubscribeUser() {


    var body = {unsubscribe: true}

    const dialogRef = this.dialog.open(PopupUserComponent, {
      width: '750px',
      data: {
        title: "Désinscription",
        message: `Une fois que vous aurez confirmé la suppression de votre compte Clem.mobi, vous ne pourrez plus réserver à travers notre plateforme.
        Conformément à la RGPD, et à nos CGUs, certaines données nécessaires pour l’activité de loueur seront conservées, pendant trois ou cinq ans selon les motifs. Aucune réinscription pour ce compte n’est possible sur cette période.`,
        buttonText: {
          ok: 'Je confirme ma demande de suppression',
          cancel: 'Annuler'
        }
      }
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {

        this.userApiService.unsubscribeUser(body).subscribe(response => {

          this.userApiService.deleteUser(this.currentUser.id).subscribe(response => {

          
            this.openSnackBar('Votre compte a été supprimé avec succès')
            this.AutorizationService.logout()
            // location.reload()
            }, error => {
            //this.openSnackBar("Le type de votre justificatif n'est pas supporté")
            this.openSnackBar(error.message)
           }
          )
          
        }, error => {
        //this.openSnackBar("Le type de votre justificatif n'est pas supporté")
        this.openSnackBar(error.message)
       }
      )
      }
    });
   


  }


  dataInit() {
    this.userApiService.getUserDetailPaiement().subscribe(response => {
      // console.log(response)
      this.currentUser = response.data;
      this.IsWait = false;
      this.getUserImg();
      this.getPermisImg();
      this.getPermisversoImg();
    })
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, "X", {
      panelClass: ['blue-snackbar'],
      duration: 20000,
    });
  }


  ngOnInit() {
    this.dataInit();
    this.createFormPermis();
    this.createFormAttachements();
    this.getCodePromo()
  }



  fileChangePermis(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        //this.openSnackBar("Seul les formats images + pdf sont autorisés")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.FORMAT'))
        return this.fileUploader.nativeElement.value = null;
      }

      this.nameFilePermis = file.name
      let typeFile = file.type

      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log(' permis recto convertir');
              this.uploadFormPermis.get('license').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('permis recto sans convertir');
            this.uploadFormPermis.get('license').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('permis recto pdf');
          this.uploadFormPermis.get('license').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }
  }


  fileChangePermisBack(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        //this.openSnackBar("Seul les formats images + pdf sont autorisés")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.FORMAT'))
        return this.fileUploaderBack.nativeElement.value = null;
      }

      this.nameFilePermisBack = file.name
      let typeFile = file.type
      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log(' permis verso convertir');
              this.uploadFormPermis.get('license_back').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('permis verso sans convertir');
            this.uploadFormPermis.get('license_back').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('permis verso pdf');
          this.uploadFormPermis.get('license_back').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }
  }




  fileChangeAttachement1(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];
      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        //this.openSnackBar("Seul les formats images + pdf sont autorisés")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.FORMAT'))
        return this.fileUploaderAttachement1.nativeElement.value = null;
      }

      this.nameFileAttachement1 = file.name
      let typeFile = file.type

      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log(' fichier1 convertir');
              this.uploadFormAttachements.get('attachement1').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('fichier1 sans convertir');
            this.uploadFormAttachements.get('attachement1').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('fichier1 pdf');
          this.uploadFormAttachements.get('attachement1').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }
  }


  fileChangeAttachement2(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        //this.openSnackBar("Seul les formats images + pdf sont autorisés")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.FORMAT'))
        return this.fileUploaderAttachement2.nativeElement.value = null;
      }

      this.nameFileAttachement2 = file.name
      let typeFile = file.type

      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log('fichier2 convertir');
              this.uploadFormAttachements.get('attachement2').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('fichier2 sans convertir');
            this.uploadFormAttachements.get('attachement2').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('fichier2 pdf');
          this.uploadFormAttachements.get('attachement2').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }

  }

  fileChangeAttachement3(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        //this.openSnackBar("Seul les formats images + pdf sont autorisés")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.FORMAT'))
        return this.fileUploaderAttachement3.nativeElement.value = null;
      }

      this.nameFileAttachement3 = file.name
      let typeFile = file.type

      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log('fichier2 convertir');
              this.uploadFormAttachements.get('attachement3').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('fichier2 sans convertir');
            this.uploadFormAttachements.get('attachement3').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('fichier2 pdf');
          this.uploadFormAttachements.get('attachement3').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }

  }

  fileChangeAttachement4(event) {

    let reader: any = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      let file = event.target.files[0];

      //type file
      var extallowed = ["image/jpg", "image/jpeg", "image/bmp", "image/gif", "image/png", "application/pdf"];
      const typeImg = file.type
      if (extallowed.indexOf(typeImg) == -1) {
        //this.openSnackBar("Seul les formats images + pdf sont autorisés")
        this.openSnackBar(this.translate.instant('ERREURPROFIL.FORMAT'))
        return this.fileUploaderAttachement4.nativeElement.value = null;
      }

      this.nameFileAttachement4 = file.name
      let typeFile = file.type

      reader.readAsDataURL(file);

      reader.onload = () => {

        var image: any = new Image()
        image.src = reader.result

        if (typeImg === "image/jpg" || typeImg === "image/jpeg" || typeImg === "image/bmp" || typeImg === "image/gif" || typeImg === "image/png") {
          if (file.size > 1000000) {
            image.onload = () => {
              var canvas = document.createElement('canvas'),
                context = canvas.getContext('2d'),
                imageWidth = 900,
                imageHeight = image.height / (image.width / imageWidth),
                data = ''
              canvas.width = imageWidth
              canvas.height = imageHeight
              context.drawImage(image, 0, 0, imageWidth, imageHeight)
              data = canvas.toDataURL(typeFile)
              // console.log('fichier2 convertir');
              this.uploadFormAttachements.get('attachement4').setValue({
                filename: file.name,
                is_link: false,
                mimetype: file.type,
                source: data.split(',')[1]
              })
            }
          } else {
            // console.log('fichier2 sans convertir');
            this.uploadFormAttachements.get('attachement4').setValue({
              filename: file.name,
              is_link: false,
              mimetype: file.type,
              source: reader.result.split(',')[1]
            })
          }
        } else {
          // console.log('fichier2 pdf');
          this.uploadFormAttachements.get('attachement4').setValue({
            filename: file.name,
            is_link: false,
            mimetype: file.type,
            source: reader.result.split(',')[1]
          })
        }
      };
    }

  }




  capture() {


    this.canvas.nativeElement.getContext("2d").drawImage(this.video.nativeElement, 0, 0, this.WIDTH, this.HEIGHT);
    console.log(this.canvas.nativeElement.getContext("2d"))
    this.isCaptured = true;
    var dataurl = this.canvas.nativeElement.toDataURL();
    this.selfieImg = {
      filename: 'selfie',
      is_link: false,
      mimetype: 'image/png',
      source: dataurl.split(',')[1]
    }

    console.log(this.selfieImg)

  }



  removeCurrent() {
    this.selfieImg = undefined
    this.isCaptured = false;
  }



  setupDevices() {

    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {

      console.log(navigator.mediaDevices)
    
      navigator.mediaDevices.getUserMedia({ video: true })

        .then(stream => {
          this.video.nativeElement.srcObject = stream;
          this.video.nativeElement.play();
          console.log(stream)
        })
        .catch( err => {
          console.log(err)
          // alert('Autorisation camera refusée');
          console.log('Autorisation camera refusée');

          const dialogReference: MatDialogRef<any, any> = this.MatDialog.open(AutorisationCameraComponent, {
            width: '1728px'
        });
  


        })

 
    }
  }




  isMamSncf(){
    if(location.host === 'mam.clem.mobi' || location.host === `www.mam.clem.mobi` ) 
    {
      return true
  
    }else
    {
      return false
    }
  }



statusDriver(driver) {

  // Compte inactif
  if (driver.is_suspended === true) {
    return this.translate.instant('PROFIL.INACTIVE');
  }

  // Suspension pour impayé
  if (driver.driver_status === 'suspended') {
    return this.translate.instant('PROFIL.SUSPENDED_PAYMENT');
  }

  // Vérification initiale des états de base
  if (driver.not_ok === false) {

    // Si le conducteur utilise l'autopartage, il doit avoir un permis
    if (driver.autopartage === true && driver.permis === false) {
      return this.translate.instant('PROFIL.PENDING_AUTOPARTAGE');
    }

    // Si autopartage sans permis → licence AM requise
    if (driver.autopartage_without_license === true && driver.license_am === false) {
      return this.translate.instant('PROFIL.PENDING_AUTOPARTAGE_NO_LICENSE');
    }

    // Si vélo → validation vélo requise
    if (driver.velo === true && driver.bike_ok === false) {
      return this.translate.instant('PROFIL.PENDING_BIKE');
    }

    // Si tout est OK
    return this.translate.instant('PROFIL.VALIDATED');
  }

  // Documents manquants
  return this.translate.instant('PROFIL.MISSING_DOCUMENTS');
}


getStatusClass(driver: any): string {

  // Compte inactif
  if (driver.is_suspended === true) {
    return 'status-gray';
  }

  // Suspension pour impayé
  if (driver.driver_status === 'suspended') {
    return 'status-red';
  }

  // Vérification initiale des états de base
  if (driver.not_ok === false) {

    // Si le conducteur utilise l'autopartage, il doit avoir un permis
    if (driver.autopartage === true && driver.permis === false) {
      return 'status-orange';
    }

    // Si autopartage sans permis → licence AM requise
    if (driver.autopartage_without_license === true && driver.license_am === false) {
      return 'status-orange';
    }

    // Si vélo → validation vélo requise
    if (driver.velo === true && driver.bike_ok === false) {
      return 'status-orange';
    }

    // Si tout est OK
    return 'status-green';
  }

  // Documents manquants
  return 'status-orange';

}


}
